import { ListItemDecorator, MenuItem, CircularProgress } from '@mui/joy';
import type { ReactElement } from 'react';
import { Add } from '@mui/icons-material';
import { useGenerateIbkrRequestTokenMutation } from 'generated/graphql';
import { useFeedback } from 'components/technical/Feedback/UseFeedback.tsx';

const createIbkrRedirectUrl = (requestToken: string): string => {
  return `https://interactivebrokers.com/authorize?oauth_token=${requestToken}`;
};

const ConnectInteractiveBrokersButton = (): ReactElement => {
  const [generateIbkrRequestToken, { loading }] = useGenerateIbkrRequestTokenMutation();
  const feedback = useFeedback();

  const handleConnectInteractiveBrokers = async (): Promise<void> => {
    try {
      const response = await generateIbkrRequestToken();
      const requestToken = response.data?.ibkrGetRequestToken;
      if (requestToken) {
        window.location.href = createIbkrRedirectUrl(requestToken);
      } else {
        feedback.showErrorMessage('Failed to obtain request token from server.');
      }
    } catch (e) {
      console.error('Error connecting to Interactive Brokers:', e);
      feedback.showGraphqlError(e);
    }
  };

  return (
    <MenuItem onClick={handleConnectInteractiveBrokers} disabled={loading}>
      <ListItemDecorator>{loading ? <CircularProgress size="sm" /> : <Add />}</ListItemDecorator>
      Interactive Brokers
    </MenuItem>
  );
};

export default ConnectInteractiveBrokersButton;
